'use client'

import { onForegroundMessage } from '@/core/firebase'
import { NotificationModel } from '@/core/types/models/notification.model'
import { addToast } from '@heroui/toast'
import { useEffect } from 'react'
import { usePushNotificationsStore } from '../store'
import { NotificationMessage } from '../ui'
import Image from 'next/image'

const playNotificationSound = () => {
  const audio = new Audio('/audio/notification.wav')
  audio.play()
}

type Params = {
  onNotification?: (notification: NotificationModel) => void
}

export const useObserveNotifications = ({ onNotification }: Params = {}) => {
  const { observers, guards } = usePushNotificationsStore()

  useEffect(() => {
    const { unsubscribe } = onForegroundMessage(notification => {
      const canActivate = guards.every(g => g.canActivate(notification))
      if (!canActivate) return

      playNotificationSound()
      onNotification?.(notification)
      const image = notification.notification?.image
      addToast({
        title: (
          <NotificationMessage
            title={notification.notification?.title || 'New notification'}
            body={notification.notification?.body}
          />
        ),
        color: 'default',
        ...(image
          ? {
              icon(props) {
                return (
                  <Image
                    src={image}
                    width={50}
                    height={50}
                    className='rounded-full'
                    alt=''
                    {...props}
                  />
                )
              },
            }
          : {}),
      })

      observers.forEach(o => o.update(notification))
    })

    return unsubscribe
  }, [guards, observers, onNotification])
}
